import React from 'react';
import { Button, Image, Modal, Stack, Text, Title } from '@mantine/core';
import promoPoster from '../assets/Fall_Pumpkin_Pie_Pedicure_Poster_60.png';

const PromoModal = ({ opened, onClose }) => (
  <Modal
    opened={opened}
    onClose={onClose}
    centered
    size="auto"
    withCloseButton
    padding={0}
    radius="xl"
    overlayProps={{ backgroundOpacity: 0.72, blur: 5 }}
    styles={{
      content: {
        background:
          'linear-gradient(145deg, rgba(255, 215, 128, 0.1), rgba(255, 255, 255, 0.03)), rgba(13, 13, 13, 0.98)',
        border: '1px solid rgba(239, 207, 127, 0.2)',
        boxShadow: '0 24px 70px rgba(0, 0, 0, 0.48)',
        width: 'min(96vw, 720px)',
        maxWidth: 'min(96vw, 720px)',
        maxHeight: '94dvh',
        overflow: 'hidden',
      },
      header: {
        background: 'transparent',
        padding: '0.35rem 0.35rem 0 0.35rem',
        minHeight: 0,
      },
      body: {
        padding: '0.1rem clamp(0.5rem, 2vw, 0.85rem) clamp(0.5rem, 2vw, 0.85rem)',
      },
      close: {
        color: '#efcf7f',
      },
    }}
  >
    <Stack gap={{ base: 'xs', sm: 'md' }}>
      <Stack gap={6} px="xs">
        <Text tt="uppercase" fw={700} c="gold.3" style={{ letterSpacing: '0.18em' }}>
          Limited-time special
        </Text>
        <Title order={2} fz={{ base: '1.35rem', sm: '1.625rem' }}>
          Fall Pumpkin Pie Special Pedicure
        </Title>
      </Stack>

      <Image
        src={promoPoster}
        alt="Pedi N. Nails Fall Pumpkin Pie Special Pedicure. Includes steamer. Now $60, originally $70. Limited-time seasonal special."
        radius="lg"
        fit="contain"
        mah="min(72vh, calc(94dvh - 180px))"
      />

      <Button color="gold" radius="xl" onClick={onClose}>
        Close
      </Button>
    </Stack>
  </Modal>
);

export default PromoModal;
